export { default } from './Content';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutLandingPage/Content/index.js